import React from 'react';

import { faStar as faRegularStar } from '@fortawesome/free-regular-svg-icons';
import { faStar as faSolidStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Box } from '@clutter/clean';

import { Landing__Location__Review } from '@admin/schema';

export const LandingLocationReviewRating: React.FC<{
  review: Pick<Landing__Location__Review, 'rating'>;
}> = ({ review: { rating } }) => (
  <Box.Flex gap="2px">
    {Array.from({ length: 5 }, (_, i) => (
      <FontAwesomeIcon key={i} icon={i < rating ? faSolidStar : faRegularStar} />
    ))}
  </Box.Flex>
);
